/** Option classification identifiers — must match backend configuration. */
export const OptionClassificationIdentifiers = {
  material: 'material_thickness',
  mountingType: 'mounting_type',
  color: 'color',
  surface: 'surface',
  background: 'background',
} as const;

/** Option identifiers within the surface classification — must match backend configuration.
 *  Anything not recognized as gloss renders matt (unfiltered). */
export const SurfaceOptionIdentifiers = {
  matte: 'matt',
  gloss: 'gloss',
} as const;

export const AttributeIdentifiers = {
  hex: 'hex',
  /** Material thickness an option supports. Colors may carry several values
   *  (e.g. '8mm' and '16mm'); material_thickness options carry exactly one. */
  thickness: 'thickness',
  /** Background option grouping: 'wall' (flat textures) or 'room' (scenes). */
  backgroundType: 'background_type',
} as const;

export const BackgroundTypes = {
  wall: 'wall',
  room: 'room',
} as const;

export const SIDEBAR_WIDTH = 400;

export const VECTOR_UPLOAD_EXTENSIONS = ['svg', 'pdf', 'eps', 'ai'];
